// src/axios.js
import axios from 'axios';

//axios.defaults.baseURL = 'http://localhost:5000/api/'; // Adjust according to your backend URL
axios.defaults.baseURL = 'https://dreamerjourney-backend.onrender.com/api/';
//axios.defaults.baseURL = 'https://dreamerstest.onrender.com/api'

axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('token')}`;
export default axios;
